export default "__VITE_ASSET__97075907__"